import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";


function AsyncSelectField({
  dbKey,
  lableKey,
  onChange,
  onBlur,
  value,
  getOptionsAPI,
  classOfInput,
  fieldUsedIn,
  disabled,
  setvalue,
  original
}) {
  const [inputValue, setValue] = useState("");
  const [cancelToken, setCancelToken] = useState();
  const [customStyles, setCustomStyles] = useState({});

  const handleInputChange = (inputvalue) => {
    setValue(inputvalue);
     if (inputValue) {
      setvalue(inputvalue);
    } 
  };
  useEffect(() => {
    const customStylesTable = {
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "#0e82ff" : "#545454",
        backgroundColor: state.isSelected ? "#d2e4ff" : "white",
        width: "100%"
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: '0px 8px 0px 0px',
      }),
      control: () => ({
        display: "flex",
        height: '30px',
        width: "230px"
      }),
      menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    };
  
    const customStylesNormal = {
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#0e82ff' : '#545454',
        backgroundColor: state.isSelected ? '#d2e4ff': 'white',
        width: "230px"
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: '0px 8px 0px 0px',
        width: "230px"
      }),
      control: () => ({
        display: "flex",
        height: '30px',
        width: "230px",
        backgroundColor : '#f8f8ff',
        borderRadius : '10px'
        
      }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    
    if (fieldUsedIn === "table") {
      setCustomStyles(customStylesTable)
    }
    else setCustomStyles(customStylesNormal)
  },[fieldUsedIn])

  var loadOptions = async function () {
      if (inputValue.length >= 2) {
          try {
              const response = await getOptionsAPI(inputValue, cancelToken, setCancelToken)
              return response.data
          } catch (error) {
          }
      }
  };

  return (
    <div>
      <AsyncSelect
        menuPortalTarget={document.body}
        styles={customStyles}
        getOptionLabel={(option) => option[lableKey]}
        getOptionValue={(option) => option[dbKey]}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={classOfInput}
        loadOptions={loadOptions}
        onInputChange={value ? handleInputChange: null}
        isDisabled={disabled}
      /> 
        <button className="async__closeBtn" onBlur={onBlur} disabled={original?.STATUS === "Hold" || original?.IsFactoryOut === 1 || original?.STATUS === "Pending" || original?.Gate_Out_Date!= null}  onClick={()=>{
            setvalue("")}}>
              <i class="bx bxs-x-square"></i>
            </button>
    </div>
  );
}

export default AsyncSelectField;
